import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service'
import { User } from '../../../shared/models/user'
import { ParametreService } from '../../../parametre/data-access/http/parametre.service'
import { NotificationService } from '../../../parametre/data-access/http/notification.service'
import { environment } from '../../../../environments/environment'
import { NotificationDisplay } from 'src/app/parametre/data-access/http/dto/notification-display'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  user: User
  famille: string
  envtest:string

  notifications: NotificationDisplay[] = [];

  constructor(
    public authService: AuthService,
    public paramService: ParametreService,
    private notificationService: NotificationService
) {}

  ngOnInit(): void {
    this.user = this.authService.connectedUser
    this.famille = this.paramService.familleParDefaut;
    this.envtest = environment.name.toUpperCase() === 'PROD' ? '' : environment.name.toUpperCase();
  }

  onOpenNotification(event : boolean) {
    if(event) {
      this.notifications = []
      this.notificationService.getNotifications().subscribe((notificationList) => {
        notificationList.forEach(notification => {
          let formattedDate = new Date(notification.createdDate).toLocaleDateString('en-GB')
          if(notification.type != "Tableau" && notification.type != "Spécifique" && notification.type != "Application" && notification.type != "Parametre") {
            this.notifications.push(
              new NotificationDisplay(
                notification.code + ": " + notification.newValue + " (" + notification.oldValue + ") ", 
                "",
                formattedDate
              )
            )
          } else if(notification.type == "Application") {
            this.notifications.push(
              new NotificationDisplay(
                "Mise à jour règle simulateur Version " + notification.newValue , 
                "App",
                formattedDate
              )
            )
          } else if(notification.type == "Parametre") {
            this.notifications.push(
              new NotificationDisplay(
                "Nouveau paramètre => " + notification.code+ ": " + notification.newValue , 
                "App",
                formattedDate
              )
            )
          } else {
            this.notifications.push(
              new NotificationDisplay(
                notification.code + " mis à jour (valeur = " + notification.type +")", 
                "",
                formattedDate
              )
            )
          }
        });

        if (this.notifications.length === 0) {
          this.notifications.push(
            new NotificationDisplay(
              "Pas de nouvelles informations",
              "",
              null
            )
          );
        }
      })
    }
  }
}
